import fflip from 'fflip';

export const hasFeature = (feature: string): boolean =>
  fflip.isFeatureEnabledForUser(feature);

export const getFeatures = () => fflip.getFeaturesForUser();

export const isEnabled = (env: string | undefined): boolean => env === 'true';
